var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"d-print-none",attrs:{"id":"logo","src":_vm.schriftzug,"title":_vm.variant,"alt":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }